import Styled, { css } from 'styled-components';

import { cssDeclaration } from '../../Utils';

export const StyledHeader = Styled.header`
  display: flex;
  margin: 0 auto;

  ${({ theme: { themeTwo }}) => {
    const { layout: { header }} = themeTwo;

    return css`
      /* background-color */ ${cssDeclaration(themeTwo, 'background-color', header.backgroundColor)};
      /* padding */ ${cssDeclaration(themeTwo, 'padding', header.padding)};
      /* box-shadow */ ${cssDeclaration(themeTwo, 'box-shadow', header.shadow)};
      /* height */ ${cssDeclaration(themeTwo, 'height', header.height)};
      /* border */ ${cssDeclaration(themeTwo, 'border', header.border)};
      /* width */ ${cssDeclaration(themeTwo, 'width', header.width)};

      ${header.position && css`
        position: sticky;
        top: 0;
        z-index: ${themeTwo.global.zIndex.highest};
      `}
    `;
  }}
`;
